//import liraries
import React, { useRef, useState } from "react";
import {
  View,
  StyleSheet,
  Dimensions,
} from "react-native";
import CText from "../../common/CText";
import CView from "../../common/CView";
import CImage from "../../common/CImage";
import AnnualProfile from "../../assets/images/annualBenifitProfile.png";
import AnnualAmbulance from "../../assets/images/annualBenifitAmbulance.png";
import AnnualBlood from "../../assets/images/annualBenifitBlood.png";
import AnnualCash from "../../assets/images/annualBenifitCash.png";
import AnnualOpd from "../../assets/images/annualBenifitOpd.png";
import AnnualEducation from "../../assets/images/annualBenifitEducation.png";
import GeneralProfile from "../../assets/images/tiGeneralBenifitsProfile.png";
import GeneralAmbulance from "../../assets/images/tiGeneralBenifitsAmbulance.png";
import GeneralBlood from "../../assets/images/tiGeneralBenifitsBlood.png";
import GeneralCash from "../../assets/images/tiGeneralBenifitsCash.png";
import GeneralOpd from "../../assets/images/tiGeneralBenifitsOpd.png";
import GeneralEducation from "../../assets/images/tiGeneralBenifitsEducation.png";
import GeneralAccidental from "../../assets/images/tiGeneralBenifitsAccidental.png";
import TI24RProfile from "../../assets/images/ti24RBenifitsProfile.png";
import TI24RAmbulance from "../../assets/images/ti24RBenifitsAmbulance.png";
import TI24RCash from "../../assets/images/ti24RBenifitsCash.png";
import TI24RHeart from "../../assets/images/ti24RBenifitsHeart.png";
import TI24SProfile from "../../assets/images/ti24SBenifitsProfile.png";
import TI24SAmbulance from "../../assets/images/ti24SBenifitsAmbulance.png";
import TI24SCash from "../../assets/images/ti24SBenifitsCash.png";
import TI24SHeart from "../../assets/images/ti24SBenifitsHeart.png";
import CViewBenifits from "../../common/CViewBenifits";
import { COLORS } from "../../constant";
import _, { conforms } from "lodash";
const { width } = Dimensions.get("window");
//1- anual

const benefitsData = [
  {
    headLine: "",
    validity: "",
    tiPlanType: "ti24R",
    descObj: [
      {
        descText:
          "Accidental Death for Rs 3 Lacs & Permanent Total Disablement due to Accident up to Rs 3 Lacs",
        descImg: TI24RProfile,
        bottomLine: true,
      },
      {
        descText: "Ambulance for Rs 5,000",
        descImg: TI24RAmbulance,
        bottomLine: true,
      },
      {
        descText: "Hospitalization due to accidents up to Rs 1.5 Lacs",
        descImg: TI24RCash,
        bottomLine: true,
      },
      {
        descText:
          "Hospitalization due to Heart Attack Myocardial Infarction and Stroke(CVA), provided same happens during the trip and is not due to a pre-existing condition up to Rs 1.5 Lacs",
        descImg: TI24RHeart,
        bottomLine: false,
      },
    ],
    color: { color: "#2680eb" },
  },
  {
    headLine: "",
    validity: "",
    tiPlanType: 'ti24S',
    descObj: [
      {
        descText:
          "Accidental Death for Rs 3 Lacs & Permanent Total Disablement due to Accident up to Rs 3 Lacs",
        descImg: TI24SProfile,
        bottomLine: true,
      },
      {
        descText: "Ambulance for Rs 5,000",
        descImg: TI24SAmbulance,
        bottomLine: true,
      },
      {
        descText: "Hospitalization due to accidents up to Rs 1.5 Lacs",
        descImg: TI24SCash,
        bottomLine: true,
      },
      {
        descText:
          "Hospitalization due to Heart Attack Myocardial Infarction and Stroke(CVA), provided same happens during the trip and is not due to a pre-existing condition up to Rs 1.5 Lacs",
        descImg: TI24SHeart,
        bottomLine: false,
      },
    ],
    color: { color: "#f7a710" },
  },
  
{
    // headLine: "Annual Trip Insurance",
    headLine: "",
    validity: "",
    tiPlanType: "tiAnnual",
    color: { color: "#7bb564" },
    descObj: [
      {
        descText:
          "Accidental Death for Rs 3 Lacs & Permanent Total Disablement due to Accident up to Rs 3 Lacs",
        descImg: AnnualProfile,
        bottomLine: true,
      },
      {
        descText: "Ambulance for Rs 5,000",
        descImg: AnnualAmbulance,
        bottomLine: true,
      },
      {
        descText: "Purchase of blood for Rs 2,000",
        descImg: AnnualBlood,
        bottomLine: true,
      },
      {
        descText:
          "Hospital Daily Cash for Rs 1,000/ day up to 60 days on hospitalization due to accident",
        descImg: AnnualCash,
        bottomLine: true,
      },
      {
        descText: "OPD expenses covered up to Rs 2,000 due to accident",
        descImg: AnnualOpd,
        bottomLine: true,
      },
      {
        descText: "Education benefits for children covered up to Rs 5,000",
        descImg: AnnualEducation,
        bottomLine: false,
      },
    ],
  },
  {
    // headLine: "TRIP INSURANCE PLANS",
    tiPlanType: "none",
    headLine: "Select Plan",
    validity: "",
    descObj: [
      {
        descText:
          "Accidental Death for Rs 3 Lacs & Permanent Total Disablement due to Accident up to Rs 3 Lacs",
        descImg: GeneralProfile,
        descHeader: "NOW GET",
        bottomLine: true,
      },
      {
        descText: "Ambulance",
        descImg: GeneralAmbulance,
        descHeader: "HOST OF OTHER BENEFITS*",
        bottomLine: true,
      },
      {
        descText: "Purchase of blood",
        descImg: GeneralBlood,
        bottomLine: true,
      },
      {
        descText: "Hospital Daily Cash",
        descImg: GeneralCash,
        bottomLine: true,
      },
      {
        descText: "OPD expenses",
        descImg: GeneralOpd,
        bottomLine: true,
      },
      {
        descText: "Education benefits",
        descImg: GeneralEducation,
        bottomLine: true,
      },
      {
        descText: "Accidental Hospitalization benefits up to Rs. 1.5 Lakhs",
        descImg: GeneralAccidental,
        bottomLine: false,
      },
    ],
    color: { color: "#16c0b5" },
  },
 
  
];

/* tiType=365A||24R||24S */
const InsurancePlanDesc = ({ type, props, allActivePlans, index, disablePrice }) => {
  let benefitsDataNew = [...benefitsData];
  console.log(allActivePlans,benefitsData,index,'annualObj33')

  if (!_.isEmpty(allActivePlans) && allActivePlans.length > 0) {
    allActivePlans.map((item) => {
        const bindex = _.findIndex(benefitsData, (val) => val.tiPlanType === item.tiPlanType);
        console
        .log(bindex,"annualObj3312")
        if (bindex > -1) {
            benefitsDataNew[bindex]['headLine'] = item.title;
            benefitsDataNew[bindex]['validity'] = `₹${Math.round(item.planPrice)}/${item.validityInDays} Day${item.validityInDays > 1 ? 's' : ''}`;
        }
    });
}
benefitsDataNew = benefitsDataNew.filter(item=>item?.headLine!=="")
if(index === false){
  index = benefitsDataNew?.length-1
}

  return (
    <View
      style={{
        width: "80%",
        height: "auto",
        borderWidth: 1.5,
        borderColor: benefitsDataNew[index]?.color.color,
        borderRadius: 10,
        paddingVertical: 0,
      }}
    >
      <View>
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            paddingHorizontal: 10,
            paddingTop: 10,
          }}
        >
          <CText.benifitPlanHeadingText style={{ color: benefitsDataNew[index]?.color.color }}>
            {benefitsDataNew[index]?.headLine}
          </CText.benifitPlanHeadingText>
          <CText.inputNoteText style={{ color: COLORS.black }}>
            {disablePrice ? "" : benefitsDataNew[index]?.validity}
          </CText.inputNoteText>
        </View>
        <View
          style={{
            width: "100%",
            height: 0.5,
            backgroundColor: "#02122c",
            opacity: 0.5,
            marginTop: 3,
          }}
        />
      </View>
      <View style={{ width: "100%", marginTop: 5 }}>
        {benefitsDataNew[index]?.descObj.map((i,index) => {
          return (
            <View style={{ width: "100%", marginTop: 0 }} key={index}>
              <CViewBenifits
                showBottomLine={i.bottomLine}
                headerText={i.descHeader}
                text={i.descText}
                imageSource={i.descImg}
              />
            </View>
          );
        })}
        <CView W100 AC></CView>
      </View>
      {benefitsDataNew[index]?.tiPlanType == "ti24R" ?
        <View style={styles.infoWidget}>
          <CText.tripInsPlanDesc>
            <CImage.TripInsInfoIcon></CImage.TripInsInfoIcon>
            {"This plan keeps you opted until you opt-out"}
          </CText.tripInsPlanDesc>
        </View>
        :null
      }
    </View>
  );
};

const styles = StyleSheet.create({
  contentWrapper: {
    width: "80%",
    gap: 18,
  },
  infoWidget:{
    backgroundColor:'#f0f9ff',
    borderRadius:10, 
    width:'80%',
    marginVertical:10,
    paddingVertical:5,
    alignItems:'center'
  }
});

export default InsurancePlanDesc;